import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import PostCard from "components/PostCard"
import { Typography, Box, CircularProgress, Fade } from "@material-ui/core"
import Masonry from "react-masonry-css"
import { openPublishContainerDialog } from "../../actions/publish-container-dialog"
// import { getPosts } from "../../actions/posts"
import { openDeletingPostDialog } from "../../actions/deleting-post-dialog"
import noPostsImg from "assets/no-posts-img.svg"
import InfiniteScroll from "react-infinite-scroll-component"

const breakpointColumnsObj = {
  default: 5,
  1800: 4,
  1400: 3,
  1000: 2,
  700: 1
}

const Posts = ({
  classes,
  dispatch,
  posts,
  isLoading,
  searchFilter,
  handleSelectCard,
  sort,
  filter
}) => {
  const [filteredPosts, setFilteredPosts] = useState([])
  const [postsPerPage, setPostsPerPage] = useState([])

  const searchPosts = () => {
    const searchRegExp = new RegExp(searchFilter, "i")
    let matches = posts.filter(post => {
      const name = post.first_name + " " + post.last_name
      return (
        post.body.search(searchRegExp) > -1 || name.search(searchRegExp) > -1
      )
    })
    if (sort) {
      if (sort.dir === "ASC") {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(a)).localeCompare(sort.getVal(b))
        )
      } else {
        matches = matches.sort((a, b) =>
          ("" + sort.getVal(b)).localeCompare(sort.getVal(a))
        )
      }
    }

    if (filter) {
      matches = matches.filter(filter.filter)
    }

    setFilteredPosts(matches)
  }

  useEffect(() => {
    searchPosts()
  }, [searchFilter, posts, sort, filter])

  const handleOpenPublishContainer = id => {
    const match = posts.filter(post => post.id === id)[0]
    dispatch(openPublishContainerDialog(match))
  }
  const handleRemove = id => {
    const data = posts.filter(post => post.id === id)[0]
    dispatch(openDeletingPostDialog(data))
  }
  let displayedPosts = searchFilter || filter || sort ? filteredPosts : posts

  const fetchMoreData = () => {
    // setTimeout(() => {
    setPostsPerPage(displayedPosts.slice(0, postsPerPage.length + 12))
    // }, 1000)
  }

  useEffect(() => {
    setPostsPerPage(displayedPosts.slice(0, 12))
  }, [displayedPosts])

  return (
    <Box style={{ width: "100%" }}>
      {!isLoading && displayedPosts.length === 0 && (
        <Fade in timeout={500}>
          <Box
            className={classes.noPostsContainer}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
          >
            <img src={noPostsImg} />
            <Typography variant="h2" className={classes.textPosts}>
              {!searchFilter ? `No Posts ${filter.name}` : "No Matches Found"}
            </Typography>
          </Box>
        </Fade>
      )}
      {!isLoading ? (
        <Box className={classes.cardContainer}>
          <InfiniteScroll
            dataLength={postsPerPage.length}
            next={fetchMoreData}
            hasMore="true"
            // loader={<h4>Loading...</h4>}
            endMessage={
              <p style={{ textAlign: "center" }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
          >
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="masonry-grid"
              columnClassName="masonry-grid_column"
            >
              {postsPerPage.length &&
                postsPerPage.map(post => {
                  return (
                    <PostCard
                      className={classes.postCardContainer}
                      handleSelectCard={handleSelectCard}
                      key={post.id}
                      post={post}
                      handleRemove={handleRemove}
                      handlePublish={() => handleOpenPublishContainer(post.id)}
                    >
                      {post.body}
                    </PostCard>
                  )
                })}
            </Masonry>
          </InfiniteScroll>
        </Box>
      ) : (
        <Box
          style={{
            display: "flex",
            justifyContent: "center"
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
    </Box>
  )
}

const mapStateToProps = state => {
  return {
    data: state.dialogsContainerDialog.data,
    posts: state.posts.data,
    isLoading: state.posts.isLoading
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(Posts))



// WEBPACK FOOTER //
// ./src/components/Posts/index.jsx